/* c8 ignore start */
import { createSSRApp } from 'vue';
import App from './GreenlightLanding.vue';

export default function createApp(props) {
  const app = createSSRApp(App, props);
  return { app };
}
